<div class="check webkit-tap-highlight-color-transparent" [class.small-switch]="isSmallSwitchButton">
  <label class="switch">
    <input
      type="checkbox"
      [ngModel]="checkedValue"
      (change)="handleClick($event)"
      [formControl]="switchControl"
      [checked]="checkedValue"
    />
    <span
      [ngStyle]="{
        'background-color': checkedValue || isChecked ? toggleActiveBgColour : toggleInactiveBgColour
      }"
      class="slider round"
    ></span>
  </label>
</div>
